import type { IndicatorVariant } from "./Badge";

export const SIZE_CONFIG = {
  sm: {
    iconPl: "pl-1",
    iconPr: "pr-1",
    dismissPr: "pr-0.5",
    btnSize: "size-3",
    iconSize: "size-2",
  },
  default: {
    iconPl: "pl-1.5",
    iconPr: "pr-1.5",
    dismissPr: "pr-1",
    btnSize: "size-3.5",
    iconSize: "size-2.5",
  },
  lg: {
    iconPl: "pl-2",
    iconPr: "pr-2",
    dismissPr: "pr-1",
    btnSize: "size-4.5",
    iconSize: "size-3",
  },
};

export const INDICATOR_COLORS: Record<IndicatorVariant, string> = {
  default: "bg-primary",
  secondary: "bg-muted-foreground",
  destructive: "bg-destructive",
  blue: "bg-blue-600",
  green: "bg-green-600",
  amber: "bg-amber-400",
  red: "bg-red-600",
  purple: "bg-purple-700",
  pink: "bg-pink-600",
  teal: "bg-teal-600",
  gray: "bg-gray-400",
};
